
/* es6-promise/auto:为vuex使用不支持promise浏览器的插件*/
//import Vue  from "vue"
import 'es6-promise/auto'
import Vuex from 'vuex'
Vue.use(Vuex);

import userModule from "./modules/userModule";
import optionsModule from "./modules/optionsModule";
const store = new Vuex.Store({
  modules:{
    userModule,optionsModule
  }
})
//定义用户模块直接使用
Vue.prototype.$storeUserModule=store.state.userModule;
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js